'use client';

import Link from 'next/link';
import ThemeChanger from './ThemeChanger';
import LanguageButton from '@/components/LanguageButton';
import config from '@/config';

export default function MainMenu({ user }) {
  const links = [
    {
      name: 'Register',
      url: '/register',
      type: 'link',
    },
    {
      name: 'Subscribe',
      type: 'anchor',
      url: 'https://share.hsforms.com/1nvRMxIK5TgyScT05Gcn6xgcda7r',
    },
    { name: 'Help', type: 'link', url: '/help' },
  ];

  const hideMenu = () => {
    const root = document.documentElement;
    root.classList.remove('menu-open');
  };

  let legacyUrl = config.APP_STAGE_LEGACY_URL;
  if (legacyUrl.indexOf('http') === -1) {
    legacyUrl = 'https://' + legacyUrl;
  }

  return (
    <div className="main-menu">
      <div className="mobile-header">
        <div className="actions-begin">
          <button onClick={hideMenu} type="button" role="toggle">
            <i className={'mio'}>arrow_back_ios</i>
            <span className="sr-only">Close Mobile Menu</span>
          </button>
        </div>
        <div className="title"></div>
        <div className="actions-end"></div>
      </div>
      <div className="container md:flex w-full md:flex-row justify-between items-center">
        <ul className="flex flex-col justify-content-start md:flex-row md:justify-between">
          <li>
            <Link
              aria-label="link to Search"
              href="/search/"
              onClick={hideMenu}
            >
              Search
            </Link>
          </li>

          <li>
            <Link
              aria-label="link to Register"
              href="/create"
              onClick={hideMenu}
            >
              Create
            </Link>
          </li>
          <li>
            <Link
              aria-label="link to Legacy UI"
              href={`${legacyUrl}/search`}
              onClick={hideMenu}
            >
              Legacy UI
            </Link>
          </li>

        </ul>

        <ul className='flex flex-col justify-content-start md:flex-row md:justify-between'>

          {links
            .filter((link) => link.name === 'Subscribe')
            .map(({ name, type, url }, index) => (
              <li key={`banner-link-set-one-${index}`}>
                <a
                  target={type === 'anchor' ? '_blank' : undefined}
                  rel={type === 'anchor' ? 'noreferrer' : undefined}
                  href={url}
                >
                  {name}
                </a>
              </li>
            ))}
          {/* Render Help link */}
          {links
            .filter((link) => link.name === 'Help')
            .map(({ name, type, url }, index) => (
              <li key={`banner-link-set-two-${index}`}>
                <Link
                  target={type === 'anchor' ? '_blank' : undefined}
                  rel={type === 'anchor' ? 'noreferrer' : undefined}
                  href={url}
                >
                  {name}
                </Link>
              </li>
            ))}
          <li>
            <ThemeChanger></ThemeChanger>
          </li>
          <li>
            {/* Render Subscribe link */}
            <LanguageButton></LanguageButton>
          </li>
        </ul>
      </div>
    </div>
  );
}
/* Advanced Search for Later Use
 {user && (
            <li>
              <Link
                aria-label="link to Advanced Search"
                href="https://ui.eidr.org/search"
                onClick={hideMenu}
              >
                Advanced Search
              </Link>
            </li>
          )}
 */